/**
 * Web implementation of SecureStorageProvider.
 * Uses localStorage so authentication credentials, user session, and vault keys
 * remain permanently active across browser reloads, tabs, and restarts until explicitly signed out.
 */
export const WebSecureStorage = {
  async setItem(key, value) {
    try {
      const serialized = typeof value === 'string' ? value : JSON.stringify(value);
      localStorage.setItem(key, serialized);
      try {
        sessionStorage.setItem(key, serialized);
      } catch {}
    } catch (e) {
      console.warn('WebSecureStorage setItem failed:', e);
    }
  },

  async getItem(key, promptMessage) {
    try {
      const value = localStorage.getItem(key) ?? sessionStorage.getItem(key);
      if (!value) {
        return null;
      }

      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    } catch {
      return null;
    }
  },

  async removeItem(key) {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch {}
  }
};
